<!--
 * Based on data provied will create a form
-->
<template>
  <div v-show="show" class="position-relative">
    <!--Create from-->
    <div v-for="(stageFieldData, index) in fieldDataList" :key="index">
      <form-widget-provider
          :disabled="stageFieldData.nonEditable"
          :optional="false"
          :hide="stageFieldData.hide"
          :ignore-value="stageFieldData.ignoreValue || stageFieldData.saveNotRequired"
          :drop-down-options="getDropDownOptions(stageFieldData)"
          :field-key="stageFieldData.field"
          :field-label="stageFieldData.fieldLabel"
          :field-value="stageFieldData.value"
          :input-type="stageFieldData.inputType"
          :validation="stageFieldData.validation"
          :error-message="stageFieldData.errorMessage"
          :hack-for-data-change="hackForDataChange"
          :ref="stageFieldData.field"
          :all-form-widget-mounted="allFormWidgetMounted"
          :input-max-length="getInputMaxLength(stageFieldData)"
          :file-upload-on-attachment="fileUploadOnAttachment"
          :file-uploaded="isFileUploaded(stageFieldData)"
          @onDropDownSelected="onDropDownSelected"
          @onFormWidgetMounted="onFormWidgetMounted"
          @onFileAttached="onFileAttached"
      ></form-widget-provider>
    </div>
    <!--Create from ends-->

    <!--Buttons start-->
    <table class="data-table-row-buttons-item margin-top-40 margin-bottom-20">
      <tr>

        <td v-if="showEditFormButton">
          <wxc-button
              text="Edit"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onEditFormButtonClicked"
          ></wxc-button>
        </td>

        <td v-if="showDismissButton">
          <wxc-button
              text="Dismiss"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onDismissFormButtonClicked"
          ></wxc-button>
        </td>

        <td v-if="showPreviousRowButton">
          <wxc-button
              text="Previous"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onPreviousRowClicked"
          ></wxc-button>
        </td>

        <td v-if="showNextRowButton">
          <wxc-button
              text="Next"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onNextRowClicked"
          ></wxc-button>
        </td>

        <td v-if="showDeleteButton">
          <wxc-button

              text="Delete"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onDeleteRowClicked"
          ></wxc-button>
        </td>

        <td v-if="showSaveButton">
          <wxc-button
              text="Save"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onSaveOrUpdateClicked"
          ></wxc-button>
        </td>

        <td v-if="showUpdateButton">
          <wxc-button
              text="Update"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onSaveOrUpdateClicked"
          ></wxc-button>
        </td>

        <td v-if="showCompleteFormButton">
          <wxc-button
              text="Next"
              class="horizontal-center"
              type="blue"
              @wxcButtonClicked="onCompleteFormClicked"
          ></wxc-button>
        </td>

      </tr>
    </table>
    <!--Buttons end-->

  </div>
</template>
<script>
import FormWidgetProvider from "../providers/FormWidgetProvider";
import {Constants} from "../Constants";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import EzUtils from '../../utils/EzUtils';
import AttributeUtil from "@/utils/AttributeUtil";
import DeepClone from "lodash.clonedeep";

export default {
  name: "DataTableRowLayout",
  components: {FormWidgetProvider, WxcButton},

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    multiRowTable: {
      type: Boolean,
      required: true,
      default: false
    },

    attributeTable: {
      type: Boolean,
      required: true,
      default: false
    },

    singleRowTable: {
      type: Boolean,
      required: true,
      default: false
    },

    allowDelete: {
      type: Boolean,
      required: true,
      default: false
    },

    allowDismiss: {
      type: Boolean,
      required: true,
      default: false
    },

    onlyForShowingData: {
      type: Boolean,
      required: true,
      default: false
    },

    processDataOneByOne: {
      type: Boolean,
      required: true,
      default: false
    },

    showAllFields: {
      type: Boolean,
      required: true,
      default: false
    },

    entityId: {
      type: Number,
      required: true,
      default: -1
    },

    entityType: {
      type: String,
      required: true,
      default: ""
    },

    dataTableName: {
      type: String,
      required: true,
      default: ""
    },

    masterDataFieldMapping: {
      type: Object,
      required: true,
      default: () => ({})
    },

    fieldDataListProp: {
      type: Array,
      required: true,
      default: () => ([])
    },

    jsonElementsProp: {
      type: Array,
      required: true,
      default: () => ([])
    },

    dataTableTemplateProp: {
      type: Object,
      required: true,
      default: () => ({})
    },

    jsonElementProp: {
      type: Object,
      required: true,
      default: () => ({})
    },

    rowIdProp: {
      type: Number,
      required: true,
      default: -1
    },

    currentRowIndex: {
      type: Number,
      required: true,
      default: -1
    },

    lastRowIndex: {
      type: Number,
      required: true,
      default: -1
    },

    nameColumnName: {
      type: String,
      default: "name"
    },

    keyColumnName: {
      type: String,
      default: "key"
    },

    valueColumnName: {
      type: String,
      default: "value"
    },

    fileUploadOnAttachment: {
      type: Boolean,
      required: true,
      default: false
    },

    /*Should be one of EDITABLE, COMPLETED_EDITABLE, READ_ONLY*/
    taskMode: {
      type: String,
      default: "EDITABLE"
    }
  },

  data: () => ({
    fields: [],
    jsonFields: {},

    dataTableTemplate: {},
    fieldDataList: [],
    rowId: -1,
    jsonElement: {},
    jsonElements: [],
    fieldToStageFieldMap: {},
    hackForDataChange: 0,
    allFormWidgetMounted: false,
    noOfMountedFormWidgets: 0,

    /*buttons visibility*/
    showDismissButton: false,
    showEditFormButton: false,
    showCompleteFormButton: false,
    showSaveButton: false,
    showUpdateButton: false,
    showDeleteButton: false,
    showPreviousRowButton: false,
    showNextRowButton: false
  }),

  methods: {
    resetLocalStates() {
      this.hideButtons();
      this.fields = [];
      this.jsonFields = {};
      this.dataTableTemplate = {};
      this.fieldDataList = [];
      this.jsonElement = {};
      this.jsonElements = [];
      this.fieldToStageFieldMap = {};
      this.rowId = -1;
      this.hackForDataChange = 0;
      this.allFormWidgetMounted = false;
      this.noOfMountedFormWidgets = 0;
    },

    hideButtons() {
      this.showDismissButton = false;
      this.showEditFormButton = false;
      this.showCompleteFormButton = false;
      this.showSaveButton = false;
      this.showUpdateButton = false;
      this.showDeleteButton = false;
      this.showPreviousRowButton = false;
      this.showNextRowButton = false;
    },

    initializeButtonsOnCreateForm() {
      if (this.onlyForShowingData) {
        this.showCompleteFormButton = true;
      } else if (this.taskMode === "READ_ONLY") {
        this.showDismissButton = true;
      } else if (this.taskMode === "COMPLETED_EDITABLE") {
        this.showDismissButton = true;
        this.showEditFormButton = true;
      } else {
        if (this.processDataOneByOne) {
          if (this.currentRowIndex > 0) {
            this.showPreviousRowButton = true;
          } else {
            this.showDismissButton = true;
          }
          this.showSaveButton = true;
        } else {
          if (this.allowDismiss) {
            this.showDismissButton = true;
          }

          if (EzUtils.isValidId(this.rowId)) {
            this.showUpdateButton = true;
            if (this.allowDelete) {
              this.showDeleteButton = true;
            }
          } else {
            this.showSaveButton = true;
          }
        }
      }
    },

    initializeButtonsOnRefreshForm() {
      if (this.currentRowIndex > 0) {
        this.showPreviousRowButton = true;
      } else {
        this.showDismissButton = true;
      }

      if (this.currentRowIndex === this.lastRowIndex) {
        this.showCompleteFormButton = true;
      } else {
        this.showNextRowButton = true;
      }
    },

    processAttributesTable() {
      const rectifiedColumnHeaderData = [];
      const rectifiedFieldDataList = [];
      const rectifiedJsonElement = {};

      this.fieldDataList && this.fieldDataList.forEach(stageFieldData => {
        if (EzUtils.isNotEmpty(this.jsonElements)) {
          this.jsonElements.forEach(jsonElement => {
            const nameColumnValue =
                EzUtils.getFieldValueForColumnName(this.nameColumnName, jsonElement);
            const keyColumnValue =
                EzUtils.getFieldValueForColumnName(this.keyColumnName, jsonElement);
            const valueColumnValue =
                EzUtils.getFieldValueForColumnName(this.valueColumnName, jsonElement);

            if (stageFieldData["field"] === keyColumnValue) {
              if (valueColumnValue) {
                rectifiedJsonElement[keyColumnValue] = valueColumnValue;
              }
            }
          });
        }

        const columnHeader = {"columnName": stageFieldData["field"],};
        rectifiedColumnHeaderData.push(columnHeader)
      });

      const rectifiedDataTableTemplate = {
        columnHeaderData: rectifiedColumnHeaderData,
        registeredTableName: this.dataTableName
      };

      this.jsonElement = rectifiedJsonElement;
      this.dataTableTemplate = rectifiedDataTableTemplate;
    },

    processDataTable() {
      const stageFieldDataList = this.fieldDataList ? [...this.fieldDataList] : [];

      if (this.showAllFields) {
        const columnHeaders = this.dataTableTemplate
            ? this.dataTableTemplate["columnHeaderData"] : null;

        columnHeaders && columnHeaders.forEach(columnHeader => {
          if (!columnHeader["isColumnPrimaryKey"]) {
            const columnName = EzUtils.getColumnNameWithoutCodeLookup(columnHeader);
            let stageFieldData =
                EzUtils.getStageFieldDataForColumnName(stageFieldDataList, columnName);

            if (!stageFieldData && columnName) {
              stageFieldData = {field: columnName};
              stageFieldDataList.push(stageFieldData);
            }
          }
        });
      }

      const convertedStageFields = [];
      stageFieldDataList.forEach(stageFieldData => {
        convertedStageFields.push(...EzUtils.convertChildFieldsToNormalField(
            null,
            stageFieldData,
            stageFieldData["dependsOnField"],
            stageFieldData["dependsOnFieldValues"]
        ));
      });

      this.fieldDataList = convertedStageFields;
    },

    refreshForm(jsonElement) {
      this.resetLocalStates();
      this.convertPropsToLocalStates();
      this.jsonElement = DeepClone(jsonElement);
      if (this.attributeTable) {
        this.processAttributesTable();
      }
      this.processDataTable();
      this.createOrRefreshFormInternally();
      this.initializeButtonsOnRefreshForm();
      this.fetchNonDependentMasterDataFromServer();
    },

    createForm() {
      if (this.attributeTable) {
        this.processAttributesTable();
      }
      this.processDataTable();
      this.createOrRefreshFormInternally();
      this.initializeButtonsOnCreateForm();
      this.fetchNonDependentMasterDataFromServer();
    },

    createOrRefreshFormInternally() {
      this.fieldDataList && this.fieldDataList.forEach(stageFieldData => {
        const fieldKey = stageFieldData.field;
        const columnHeader = EzUtils.getColumnHeaderForColumnName(this.dataTableTemplate, fieldKey);

        if (stageFieldData["hide"]) {
          stageFieldData["hide"] = true;
          if (!columnHeader) {
            stageFieldData["ignoreValue"] = true;
          } else {
            stageFieldData["ignoreValue"] = false;
          }
        } else {
          stageFieldData["hide"] = false;
          stageFieldData["ignoreValue"] = false;
        }

        if (stageFieldData["nonEditable"]) {
          stageFieldData["nonEditable"] = true;
        } else {
          stageFieldData["nonEditable"] = false;
        }

        let fieldValue = "";
        if (EzUtils.isFieldNested(fieldKey)) {
          fieldValue = EzUtils.getFieldValueForChildObject(fieldKey, this.jsonElement);
          const parentFieldKey = EzUtils.getParentFieldName(fieldKey);
          this.jsonFields[parentFieldKey] = EzUtils.setNestedJsonFields(
              fieldKey,
              1,
              this.jsonFields[parentFieldKey],
              fieldValue
          );
        } else {
          fieldValue = EzUtils.getFieldValueForColumnHeader(columnHeader, this.jsonElement);
        }

        if (fieldValue) {
          stageFieldData["value"] = fieldValue;
        }

        let fieldLabel = stageFieldData.fieldLabel;
        if (!fieldLabel) {
          let actualFieldName = stageFieldData["field"];
          if (EzUtils.isFieldNested(actualFieldName)) {
            actualFieldName = EzUtils.getChildFieldName(actualFieldName);
          }
          fieldLabel = EzUtils.removeCharsAndJoinWithUpperCase(actualFieldName, "_", "\\.");
        }
        stageFieldData["fieldLabel"] = fieldLabel;

        const columnDisplayType = columnHeader ? columnHeader["columnDisplayType"] : "";

        stageFieldData["errorMessage"] = "Enter valid " + fieldLabel;
        if (EzUtils.isNotEmpty(stageFieldData["masterData"])
            || stageFieldData["dependentMasterData"]
            || stageFieldData["inputType"] === "DROPDOWN"
            || columnDisplayType === Constants.CODELOOKUP
            || columnDisplayType === Constants.CODEVALUE
        ) {
          stageFieldData["inputType"] = "DROPDOWN";
          stageFieldData["errorMessage"] = "Select " + fieldLabel;

          const fieldValues = [];
          if (EzUtils.isNotEmpty(stageFieldData["masterData"])) {
            fieldValues.push(...stageFieldData["masterData"]);
          } else if (columnHeader && EzUtils.isNotEmpty(columnHeader["columnValues"])) {
            columnHeader["columnValues"].forEach(columnValue => {
              fieldValues.push(columnValue["value"]);
            })
          }

          stageFieldData["dropDownOptions"] = fieldValues;
        } else if (stageFieldData["inputType"] === "INTEGER" || columnDisplayType === "INTEGER") {
          stageFieldData["inputType"] = "INTEGER";
        } else if (stageFieldData["inputType"] === "DECIMAL" || columnDisplayType === "DECIMAL") {
          stageFieldData["inputType"] = "DECIMAL";
        } else if (stageFieldData["inputType"] === "BOOLEAN" || columnDisplayType === "BOOLEAN") {
          stageFieldData["inputType"] = "BOOLEAN";
          stageFieldData["errorMessage"] = "Select " + fieldLabel;
        } else if (stageFieldData["inputType"] === "DATE" || columnDisplayType === "DATE") {
          stageFieldData["inputType"] = "DATE";
          stageFieldData["errorMessage"] = "Select " + fieldLabel;
        } else {
          stageFieldData["inputType"] = "STRING";
        }

        this.fieldToStageFieldMap[fieldKey] = stageFieldData;
        this.fields.push(fieldKey);
      })
    },

    getDropDownOptions(stageFieldData) {
      if (stageFieldData && EzUtils.isNotEmpty(stageFieldData["dropDownOptions"])) {
        return stageFieldData["dropDownOptions"];
      }
      return [];
    },

    getInputMaxLength(stageFieldData) {
      if (stageFieldData && stageFieldData["inputMaxLength"]) {
        return stageFieldData["inputMaxLength"];
      }
      return -1;
    },

    isFileUploaded(stageFieldData) {
      if (stageFieldData && EzUtils.isBoolean(stageFieldData["documentUploaded"])) {
        return stageFieldData["documentUploaded"];
      }
      return false;
    },

    onFormWidgetMounted() {
      this.noOfMountedFormWidgets++;
      if (this.fieldDataList.length === this.noOfMountedFormWidgets) {
        this.allFormWidgetMounted = true;
      }
    },

    onDropDownSelected(selectedSpinnerKey, value) {
      if (selectedSpinnerKey) {
        const masterValuesRequestDtoMap = {};

        this.fieldDataList.forEach(stageFieldData => {
          if (this.doesFieldDependsOnSpinnerForVisibility(selectedSpinnerKey, stageFieldData)) {
            const parentFormWidget = this.getFormWidgetRef(selectedSpinnerKey);
            const dependentFormWidget = this.getFormWidgetRef(stageFieldData["field"]);

            if (dependentFormWidget) {
              if (!parentFormWidget
                  || EzUtils.isEmpty(parentFormWidget.getValue())
                  || EzUtils.isEmpty(stageFieldData["dependsOnFieldValues"])
                  || !stageFieldData["dependsOnFieldValues"].includes(parentFormWidget.getValue())
              ) {
                stageFieldData["hide"] = true;
                stageFieldData["ignoreValue"] = true;
              } else {
                stageFieldData["hide"] = false;
                stageFieldData["ignoreValue"] = false;
              }
            }
          }

          if (this.doesFieldDependsOnSpinnerForMasterData(
              selectedSpinnerKey, stageFieldData["dependentMasterData"]
          )) {
            if (stageFieldData["dependentMasterData"]["fetchFromServer"]) {
              const fetchMasterData = stageFieldData["dependentMasterData"]["fetchMasterData"];
              let applicableForFetching = true;
              const dependentValueMap = {};
              fetchMasterData["dependsOnFields"].forEach(dependsOnField => {
                const dependsOnFieldFormSpinnerRef = this.getFormWidgetRef(dependsOnField);
                if (!dependsOnFieldFormSpinnerRef
                    || EzUtils.isEmpty(dependsOnFieldFormSpinnerRef.getValue())
                ) {
                  applicableForFetching = false;
                } else {
                  dependentValueMap[this.getFieldToFetchMasterData(dependsOnField)] =
                      dependsOnFieldFormSpinnerRef.getValue();
                }
              });

              if (applicableForFetching) {
                masterValuesRequestDtoMap[stageFieldData["field"]] = {
                  master_name: fetchMasterData["masterName"],
                  column_name: this.getFieldToFetchMasterData(stageFieldData["field"]),
                  dependent_value_map: dependentValueMap
                }
              }
            } else {
              this.setSpinnerOptions(
                  stageFieldData["field"],
                  this.getDependentSpinnerValue(stageFieldData["dependentMasterData"])
              );
            }
          }
        });

        this.hackForDataChange--;
        if (Object.keys(masterValuesRequestDtoMap).length > 0) {
          this.$emit("onFetchMasterDataFromServer", masterValuesRequestDtoMap);
        }
      }
    },

    onFileAttached(fieldKey, file) {
      this.$emit("onFileAttached", fieldKey, file);
    },

    onFileUploaded(fieldKey, documentId) {
      const fieldRef = this.getFormWidgetRef(fieldKey);
      if (fieldRef) {
        fieldRef.onFileUploaded(documentId);
      }
    },

    doesFieldDependsOnSpinnerForVisibility(parentSpinnerKey, stageFieldData) {
      if (!stageFieldData || !parentSpinnerKey) {
        return false;
      }

      return parentSpinnerKey === stageFieldData["dependsOnField"];
    },

    doesFieldDependsOnSpinnerForMasterData(parentSpinnerKey, fieldMasterData) {
      if (!fieldMasterData) {
        return false;
      }

      if (fieldMasterData["fetchFromServer"]) {
        const fetchMasterData = fieldMasterData["fetchMasterData"];
        if (!fetchMasterData || EzUtils.isEmpty(fetchMasterData["dependsOnFields"])) {
          return false;
        }
        return fetchMasterData["dependsOnFields"].includes(parentSpinnerKey);
      }

      const dependsOnField = fieldMasterData["dependsOnField"];

      if (parentSpinnerKey === dependsOnField) {
        return true;
      }

      let childDependentMasterData = null;

      if (fieldMasterData["dependentMasterDataMap"]) {
        const childFormSpinner = this.getFormWidgetRef(dependsOnField);
        if (childFormSpinner
            && EzUtils.isNotEmpty(childFormSpinner.getValue())
            && fieldMasterData["dependentMasterDataMap"][childFormSpinner.getValue()]
        ) {
          childDependentMasterData =
              fieldMasterData["dependentMasterDataMap"][childFormSpinner.getValue()];
        }
      }

      return this.doesFieldDependsOnSpinnerForMasterData(
          parentSpinnerKey, childDependentMasterData
      );
    },

    getDependentSpinnerValue(fieldMasterData) {
      if (!fieldMasterData) {
        return [];
      }
      const childSpinnerKey = fieldMasterData["dependsOnField"];

      if (EzUtils.isEmpty(childSpinnerKey)) {
        return [];
      }

      const childFormSpinnerRef = this.getFormWidgetRef(childSpinnerKey);
      if (!childFormSpinnerRef || EzUtils.isEmpty(childFormSpinnerRef.getValue())) {
        return [];
      }

      const childFormSpinnerValue = childFormSpinnerRef.getValue();

      if (fieldMasterData["dependentMasterDataMap"]) {
        return this.getDependentSpinnerValue(
            fieldMasterData["dependentMasterDataMap"][childFormSpinnerValue]
        );
      }

      if (fieldMasterData["map"]
          && EzUtils.isNotEmpty(fieldMasterData["map"][childFormSpinnerValue])
      ) {
        return fieldMasterData["map"][childFormSpinnerValue];
      }

      return [];
    },

    getFormWidgetRef(field) {
      let fieldRef = null;
      if (field && EzUtils.isNotEmpty(this.$refs[field])) {
        fieldRef = this.$refs[field][0];
      }
      return fieldRef;
    },

    fetchNonDependentMasterDataFromServer() {
      const masterValuesRequestDtoMap = {};
      this.fieldDataList.forEach(stageFieldData => {
        const dependentMasterData = stageFieldData["dependentMasterData"];
        if (dependentMasterData && dependentMasterData["fetchFromServer"]) {
          const fetchMasterData = dependentMasterData["fetchMasterData"];

          if (fetchMasterData
              && EzUtils.isEmpty(fetchMasterData["dependsOnFields"])
              && EzUtils.isNotEmpty(fetchMasterData["masterName"])
          ) {
            masterValuesRequestDtoMap[stageFieldData["field"]] = {
              master_name: fetchMasterData["masterName"],
              column_name: this.getFieldToFetchMasterData(stageFieldData["field"]),
              dependent_value_map: {}
            };
          }
        }
      });

      if (Object.keys(masterValuesRequestDtoMap).length > 0) {
        this.$emit("onFetchMasterDataFromServer", masterValuesRequestDtoMap);
      }
    },

    getFieldToFetchMasterData(fullFieldName) {
      let field;
      const fieldWithoutChildSeparator = EzUtils.getChildFieldName(fullFieldName);
      const stageFieldData = this.fieldToStageFieldMap[fullFieldName];

      if (this.masterDataFieldMapping && this.masterDataFieldMapping[fullFieldName]) {
        field = this.masterDataFieldMapping[fullFieldName];
      } else if (stageFieldData) {
        if (stageFieldData["childFieldCreatedManually"]
            && this.masterDataFieldMapping
            && this.masterDataFieldMapping[fieldWithoutChildSeparator]
        ) {
          field = this.masterDataFieldMapping[fieldWithoutChildSeparator];
        } else {
          field = fieldWithoutChildSeparator;
        }
      } else {
        field = fieldWithoutChildSeparator;
      }

      return field;
    },

    onMasterDataFetched(masterDataMap) {
      if (masterDataMap && Object.keys(masterDataMap).length > 0) {
        const masterFields = Object.keys(masterDataMap);
        masterFields.forEach(masterField => {
          this.setSpinnerOptions(masterField, masterDataMap[masterField])
        })
      }
      this.hackForDataChange++;
    },

    setSpinnerOptions(field, options) {
      if (!field) {
        return;
      }

      options = EzUtils.isNotEmpty(options) ? options : [];
      const stageFieldData = this.fieldToStageFieldMap[field];
      if (stageFieldData) {
        stageFieldData["dropDownOptions"] = options;
      }
      //TODO @Anish keep previous selected value;
    },

    onEditFormButtonClicked() {

    },

    onDismissFormButtonClicked() {
      this.$emit("onDismissFormButtonClicked");
    },

    onPreviousRowClicked() {
      this.$emit("onPreviousRowClicked");
    },

    onNextRowClicked() {
      this.$emit("onNextRowClicked");
    },

    onDeleteRowClicked() {

    },

    onCompleteFormClicked() {
      this.$emit("onCompleteFormClicked");
    },

    onSaveOrUpdateClicked() {
      if (this.checkForValidation()) {
        if (this.attributeTable) {
          this.$emit("onSaveAttributeDetails", this.getAttributesDto());
        } else if (this.singleRowTable) {
          this.$emit("onSaveOrUpdateSingleRowDataTable",
              this.entityId, this.dataTableName, this.getDataTablePayload()
          );
        } else {
          this.$emit("onSaveOrUpdateMultiRowDataTable",
              this.rowId, this.entityId, this.dataTableName, this.getDataTablePayload()
          );
        }
      }
    },

    checkForValidation() {
      let valid = true;
      this.fields.forEach(field => {
        const fieldRef = this.$refs[field][0];
        if (fieldRef
            && !fieldRef.isIgnoreValue()
            && fieldRef.isEnabled()
            && fieldRef.isNotValid()
        ) {
          valid = false;
          fieldRef.showError();
        }
      })
      return valid;
    },

    /**
     *
     * @returns [...{"field" : "fieldKey", "label":"fieldLabel","value":"fieldValue"}]
     */
    getFieldsDataInfo() {
      const fieldsDataInfo = [];
      this.fields.forEach(field => {
        const fieldRef = this.$refs[field][0];
        if (fieldRef && !fieldRef.isIgnoreValue() && EzUtils.isNotEmpty(fieldRef.getValue())) {
          fieldsDataInfo.push({
            field: field,
            label: fieldRef.getLabel(),
            value: fieldRef.getValue(),
          })
        }
      })

      return fieldsDataInfo;
    },

    getAttributesDto() {
      const fieldsDataInfo = this.getFieldsDataInfo();
      const attributes = [];
      fieldsDataInfo.forEach(fieldDataInfo => {
        attributes.push(AttributeUtil.getSingleAttributeData(
            fieldDataInfo.field,
            fieldDataInfo.label,
            fieldDataInfo.value
        ));
      });

      return AttributeUtil.getAttributeUpdateDtoFromList(
          this.entityType, this.entityId, attributes
      );
    },

    getDataTablePayload() {
      const fieldsDataInfo = this.getFieldsDataInfo();
      const payload = {};

      fieldsDataInfo.forEach(fieldDataInfo => {
        const fieldKey = fieldDataInfo.field;
        const fieldValue = fieldDataInfo.value;
        if (EzUtils.isFieldNested(fieldKey)) {
          const parentFieldKey = EzUtils.getParentFieldName(fieldKey);
          this.jsonFields[parentFieldKey] = EzUtils.setNestedJsonFields(
              fieldKey,
              1,
              this.jsonFields[parentFieldKey],
              fieldValue
          );
        } else {
          payload[fieldKey] = fieldValue;
        }
      });

      const jsonFieldsKeys = Object.keys(this.jsonFields);
      if (jsonFieldsKeys.length > 0) {
        jsonFieldsKeys.forEach(jsonFieldKey => {
          const jsonFieldValue = this.jsonFields[jsonFieldKey];
          if (jsonFieldValue) {
            payload[jsonFieldKey] = JSON.stringify(jsonFieldValue);
          }
        });
      }

      return payload;
    },

    convertPropsToLocalStates() {
      //Convert props to local state
      this.rowId = this.rowIdProp;
      this.jsonElement = DeepClone(this.jsonElementProp);
      this.jsonElements = DeepClone(this.jsonElementsProp);
      this.fieldDataList = DeepClone(this.fieldDataListProp);
      this.dataTableTemplate = DeepClone(this.dataTableTemplateProp);
    }
  },

  mounted() {
    this.resetLocalStates();
    this.convertPropsToLocalStates();
    this.createForm();
  }
};
</script>

<style scoped>

.data-table-row-buttons-item {
  table-layout: fixed;
  width: 100%;
}

</style>

<style
    scoped
    src="../../assets/style/base.css"></style>
